import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ActiveCCRDialogProps {
  showActiveCCRDialog: boolean;
  setshowActiveCCRDialog: (setshowActiveCCRDialog: boolean) => void;
  setShowContactForm: (showContactForm: boolean) => void;
}

export const ActiveCCRDialog = ({
  showActiveCCRDialog,
  setshowActiveCCRDialog,
  setShowContactForm,
}: ActiveCCRDialogProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setshowActiveCCRDialog(false);
  };

  const handleContact = () => {
    setshowActiveCCRDialog(false);
    setShowContactForm(true);
  };

  return (
    <div>
      <Dialog
        open={showActiveCCRDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('MessageTitleInformation')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('MessageDuplicatedCCR')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('ok')}</Button>
          <Button onClick={handleContact} autoFocus>
            {t('Contact')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
